const EVIDENCE_FIELD_KEYS = {
  // CORE
  incidentNumber: 'IncidentID',
  ptsIncidentID: 'ptsIncidentID',
  ptsEvidenceID: 'ptsEvidenceID',
  evidenceID: 'EvidenceID',
  category: 'Category',
  categoryId: 'CategoryID',
  propertyType: 'PropertyType',
  propertyTypeId: 'PropertyTypeID',
  description: 'Description',
  clearanceLevel: 'ClearanceLevel',
  statusCode: 'Status',
  statusId: 'StatusId',
  daysInEvidence: 'DaysInEvidence',

  // STANDARD
  requiredAction: 'RequiredAction',
  requiredActionId: 'RequiredActionID',
  tagNumber: 'TagNumber',
  actionDate: 'ActionDate',
  evidenceType: 'EvidenceType',
  evidenceTypeId: 'EvidenceTypeID',
  quantity: 'Quantity',
  collectedBy: 'CollectedBy',
  collectedByPersonID: 'CollectedByPersonID',
  dateTimeCollected: 'DateTimeCollected',
  locationCollected: 'LocationCollected',
  propertyOwner: 'PropertyOwner',
  propertyOwnerType: 'PropertyOwnerType',
  propertyOwnerTypeID: 'PropertyOwnerTypeID',

  disposalCode: 'DisposalCode',
  disposalCodeId: 'DisposalCodeID',
  offenses: 'offenses',
  offensesList: 'offensesList',

  // PHYSICAL
  make: 'Make',
  model: 'Model',
  serialNumber: 'SerialNumber',
  vin: 'VIN',
  licenseNumber: 'LicenseNumber',

  // SUBSTANCE
  substanceType: 'SubstanceType',
  substanceTypeId: 'SubstanceTypeID',
  substanceClass: 'SubstanceClass',
  substanceClassId: 'SubstanceClassID',
  measurement: 'Measurement',
  measurementID: 'MeasurementID',

  notes: 'Notes',

  // Extra Fields
  currentLocation: 'CurrentLocation',
  receivedDate: 'ReceivedDate',
  receivedBy: 'ReceivedBy',

  // Submit Evidence
  submittedByID: 'submittedByID',
  submittedBy: 'submittedBy',
  submittedAt: 'submittedAt',
  temporaryLocationID: 'temporaryLocationID',
  temporaryLocation: 'temporaryLocation',
};

export const EVI_PHYSICAL_FIELDS = [
  EVIDENCE_FIELD_KEYS.make,
  EVIDENCE_FIELD_KEYS.model,
  EVIDENCE_FIELD_KEYS.serialNumber,
  EVIDENCE_FIELD_KEYS.vin,
  EVIDENCE_FIELD_KEYS.licenseNumber,
];

export const EVI_SUBSTANCE_FIELDS = [
  EVIDENCE_FIELD_KEYS.substanceTypeId,
  EVIDENCE_FIELD_KEYS.substanceType,
  EVIDENCE_FIELD_KEYS.substanceClassId,
  EVIDENCE_FIELD_KEYS.substanceClass,
  EVIDENCE_FIELD_KEYS.measurement,
  EVIDENCE_FIELD_KEYS.measurementID,
];

export const EVIDENCE_DISPOSITION_FIELDS = {
  ptsEvidenceDispositionID: 'ptsEvidenceDispositionID',
  readyForDisposal: 'readyForDisposal',
  excludeFromDisposalRules: 'excludeFromDisposalRules',
  finalDispositionId: 'finalDispositionId',
  finalDispositionLabel: 'finalDispositionLabel',
  dispositionDate: 'dispositionDate',
  disposedBy: 'disposedBy',
  disposedById: 'disposedById',
  returnedBy: 'returnedBy',
  returnedById: 'returnedById',
  returnedDate: 'returnedDate',
  returnedTo: 'returnedTo',
  returnedToId: 'returnedToId',
  releasedTo: 'releasedTo',
  releasedToId: 'releasedToId',
  dispositionNotes: 'dispositionNotes',
  howDestroyedId: 'howDestroyedId',
  howDestroyedLabel: 'howDestroyedLabel',
  destructionDate: 'destructionDate',
  destructionReturnDate: 'destructionReturnDate',
  isDispositionRecorded: 'isDispositionRecorded',
};

export const EVIDENCE_CUSTODY_FIELDS = {
  ptsEvidenceCustodyID: 'ptsEvidenceCustodyID',
  ptsIncidentID: 'ptsIncidentID',
  ptsEvidenceID: 'ptsEvidenceID',
  EvidenceID: 'EvidenceID',
  Status: 'Status',
  StatusID: 'StatusID',
  CustodyFrom: 'CustodyFrom',
  CustodyTo: 'CustodyTo',
  ReasonID: 'ReasonID',
  Reason: 'Reason',
  Notes: 'Notes',
  RequiredActionID: 'RequiredActionID',
  RequiredAction: 'RequiredAction',
  ReadyForDisposal: 'ReadyForDisposal',
  DisposalCode: 'DisposalCode',
  DisposalCodeID: 'DisposalCodeID',
  TransactionDate: 'TransactionDate',
  TransactionType: 'TransactionType',
  ComeFromCheckInFlow: 'ComeFromCheckInFlow',
  StorageLocation: 'StorageLocation',
  StorageLocationID: 'StorageLocationID',
  SubLocation: 'SubLocation',
  SubLocationID: 'SubLocationID',
  Container: 'Container',
  ContainerID: 'ContainerID',
  ExpectedReturnDate: 'ExpectedReturnDate',
  CustodyToPtsPersonID: 'CustodyToPtsPersonID',
  CustodyToEmail: 'CustodyToEmail',
  RecordedBy: 'RecordedBy',
  RecordedDate: 'RecordedDate',
  PrintReceipt: 'PrintReceipt',
  CreatedBy: 'CreatedBy',
  CreatedDate: 'Created',
};

export default EVIDENCE_FIELD_KEYS;
